import React from 'react';
//
import Loading from 'shared/loading';
import { usePrismicData } from '../../hooks/prismic';
//
import Feed from './feed';
//
export default ({ items, username }) => {
  // Generate blacklist from Prismic
  let blacklist = [];

  const { doc, error, loading } = usePrismicData({
    documentType: 'instagram',
    documentUID: username,
  });

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (doc) {
    blacklist = doc.data.black_list.map(({ id }) => id);
  }

  const filteredItems = items.filter(
    ({ node }) => !blacklist.includes(node.shortcode)
  );

  return <Feed items={filteredItems} />;
};
